<nav class="fixed top-0 left-0 right-0 z-50 bg-white">
    <div id="header" class="flex items-center justify-between bg-white py-4 text-lg md:px-[40px] sl:px-[16px] sl:py-[16px] max-w-[1920px] mx-auto">
        <div class="flex items-center">
            <a *ngFor="let item of menuItems" [routerLink]="item.link" routerLinkActive="active" class="menu relative md:mr-12">
                <ng-container *ngIf="item.image; else textContent">
                    <img [src]="item.image" [alt]="item.title" />
                </ng-container>
                <ng-template #textContent>
                    <div class="hidden xl:block">
                        <span class="font-normal">{{ item.title }}</span>
                        <span class="absolute line"></span>
                    </div>
                </ng-template>
            </a>
        </div>
        <div class="flex items-center justify-between">
            <button class="t-button-defult md:py-[10px] md:px-[26px] sl:py-[6px] sl:px-[14px]" [routerLink]="['/main/contact-us']" routerLinkActive="t-button-defult-active" *ngIf="showContactUsButton">Contact Us</button>
            <div class="block xl:hidden md:ml-[32px] sl:ml-[16px]">
                <img class="menu-list" [src]="isPanelOpen ? 'assets/images/close.svg' : 'assets/images/menu-list.svg'" (click)="togglePanel()" />
            </div>
        </div>
    </div>
    <div id="menu-panel" *ngIf="isPanelOpen" class="absolute right-0 w-full bg-white z-10 sl:px-[16px] sl:pt-[16px] sl:pb-[24px] md:px-[40px] md:pt-[32px] md:pb-[40px] xl:hidden" [ngClass]="{ 'separator-line': isPanelOpen }">
        <ng-container *ngFor="let menu of menuItemsForPanel">
            <a href="#" class="flex md:text-20 md:py-[24px] md:pl-[12px] sl:text-16 sl:py-[16px] sl:pl-[12px] sl:leading-150 md:leading-100" [routerLink]="menu.link" routerLinkActive="active" (click)="togglePanel()">
                {{ menu.title }}
            </a>
        </ng-container>
    </div>
</nav>
